<!-- <div class="box"> -->
    <div class="shine">
        <div class="box" [style.height]="boxHeight" [style.width]="boxWidth"></div>
    </div>
<!-- </div> -->